import { LogDescription } from "ethers/lib/utils"

const getLog = (logs: LogDescription[], logName: string) => {
  const log = logs?.find((log) => log.name === logName)
  return log && log?.args
}

export default getLog
